import { fetch } from 'wix-fetch';
import wixData from 'wix-data';
import wixWindow from 'wix-window';
import { getSecFilingsXml, getEntryFileLink, getStockDataFromApi, updatePrDbIfNeeded, updateSecFilingsDbIfNeeded } from 'backend/fetchData';
import { parseSecXml, saveSecFilings, convertSecItemDate, getXbrlLink } from 'public/secFilingsFunctions';


const options = {
	day: "numeric",
	month: "short",
	year: "numeric"
};

const fieldsEvents = [
	{ id: 'presentation', name: 'RSVP' },
	{ id: 'pressRelease', name: 'PR' },
	{ id: 'summary', name: 'SLIDES' },
	{ id: 'transcript', name: 'SCRIPT' },
	{ id: 'shareholderUpdate', name: 'UPDATE' },
	{ id: 'asc606Reconciliations', name: 'RECON' },
	{ id: 'webcast', name: 'WEBCAST' }
]

function orderResultsByKey(key, order = 'asc') {
	return function (a, b) {
		const varA = a[key];
		const varB = b[key];
		let comparison = 0;

		if (varA > varB) {
			comparison = 1;
		} else if (varA < varB) {
			comparison = -1;
		}
		return ((order === 'desc') ? (comparison * -1) : comparison);
	};
}

$w.onReady(async function () {
	if (wixWindow.rendering.env === "browser") {
		//update ticker data
		getStockDataFromApi().then(() => {
			$w("#stockTickerData").refresh();
		});
	}

	/* NASDAQ Ticker */
	$w('#tickerPrice, #tickerChange, #tickerVolume, #tickerText').show();

	/* Quarterly Results */
	const repeaterItems = ['item1', 'item2', 'item3', 'item4', 'item5'];

	$w("#quarterlyResultsRepeater").onItemReady(($w, itemData, index) => {
		$w("#title").text = itemData.title;
		$w("#subtitle").text = itemData.subtitle;

		repeaterItems.forEach(item => {
			if (itemData.hasOwnProperty(item + 'Text')) {
				$w('#' + item + 'Text').link = itemData[item + 'Url'];
				$w('#' + item + 'Text').label = itemData[item + 'Text'];
				$w('#' + item + 'Text').show();
				$w('#' + item + 'Arrow').show();
			}
		});
	});

	/* Events */
	initializeEventsRepeater();

	const OFFSET = 0;
	const LIMIT = 6;
	const prItemStyle = 'font: normal normal normal 14px/1.4em helveticaneuew01-45ligh,sans-serif; color: #000000;';

	/* Governance Docs */

	const governanceDocsNum = $w("#governanceDocsRepeater").data.length;

	$w("#governanceDocsRepeater").onItemReady(($w, itemData, index) => {
		$w("#GdItemTitle").text = itemData.title;
		$w('#GdItemFile1').link = itemData.file;
		if ($w("#governanceDocsRepeater").collapsed) {
			$w("#governanceDocsRepeater").expand();
		}
		if ((index) === 3) {
			$w('#governanceDocsItemSep').collapse();
		}
	});

	await Promise.all([getEvents(), getGovernanceDocs(), getQuarterlyResults(), initializeSecFilingsRepeater(), updatePrDbIfNeeded()]);
});

const getGovernanceDocs = () => wixData.query("governanceDocsDatabase")
	.eq("category", "Governance")
	.limit(4)
	.find()
	.then((results) => {
		$w('#governanceDocsRepeater').data = results.items;
	})
	.catch((error) => {
		let errorMsg = error.message;
		let code = error.code;
	});

const getEvents = () => wixData.query("eventsDatabase")
	.limit(4)
	.descending('date')
	.find()
	.then((results) => {
		$w('#eventsRepeater').data = results.items;
	})
	.catch((error) => {
		let errorMsg = error.message;
		let code = error.code;
	});

const initializeSecFilingsRepeater = () => updateSecFilingsDbIfNeeded()
	.then((result) => {
		populateSecItems(result);
	})
	.then(() => {
		$w('#secFilingsRepeater').expand();
	})
	.catch((err) => {
		let errorMsg = err;
	});

export async function getQuarterlyResults(event) {
	const currentYear = (new Date()).getFullYear().toString();
	const previousYear = ((new Date()).getFullYear() - 1).toString();
	return wixData.query("quarterlyResults")
		.limit(8)
		.ge('year', previousYear)
		.find()
		.then((results) => {
			let quarterlyResultitems = results.items.reverse();
			quarterlyResultitems = quarterlyResultitems.sort(orderResultsByKey('itemsOrder', 'desc')).sort(orderResultsByKey('year', 'desc'));
			const last4 = quarterlyResultitems.slice(0, 4);
			$w("#quarterlyResultsRepeater").data = last4;
		});
}

const initializeEventsRepeater = () => {
	const linkStyleDesktop = 'margin-left: 25px; font: normal normal normal 14px/1.4em helveticaneuew01-55roma,sans-serif; text-transform: uppercase; border-bottom: 1px solid #000; color: #000; padding-bottom: 3px;';
	const linkStyleMobile = 'display: inline-block; margin: 0 15px 15px 0; font: normal normal normal 12px/1.4em helveticaneuew01-55roma,sans-serif; text-transform: uppercase; border-bottom: 1px solid #000; color: #000; padding-bottom: 3px;';
	let linkStyle = (wixWindow.formFactor === "Mobile") ? linkStyleMobile : linkStyleDesktop;
	const eventsNum = $w("#eventsRepeater").data.length;

	$w("#eventsRepeater").onItemReady(($w, itemData, index) => {
		$w("#eventTitle").text = itemData.title;
		$w('#eventDateTime').text = itemData.date.toLocaleDateString("en-US", options).toUpperCase();

		if ($w('#eventsRepeater').collapsed) {
			$w('#eventsRepeater').expand();
		}
		let itemFields = [];

		fieldsEvents.forEach((field, index) => {
			if (itemData[field['id']]) {
				itemFields.push(fieldsEvents[index]);
			}
		});

		let linksHtml = [];

		itemFields.forEach((field, index) => {
			let id = field.id.toString();
			let name = field.name.toString();

			if (itemData[id]) {
				let link = itemData[id];
				linksHtml.push(`<a class="customLink" style="${linkStyle}" href="${link}">${name}</a>`);
			}
		});

		if (index === 3) {
			$w('#eventSep').collapse();
		}

		linksHtml = linksHtml.join('');
		$w('#eventButtonsHolder').html = `<div style="text-align: right;">${linksHtml}</div>`;
	});
}

const populateSecItems = (repeaterData) => {

	$w("#secFilingsRepeater").onItemReady(($item, itemData, index) => {
		$item("#dateFiled").text = itemData.dateFiled;
		$item("#description").text = itemData.title;
		$item("#filing").text = itemData.filing;
		const xbrlLink = getXbrlLink($item("#dateFiled").text);

		if (xbrlLink) {
			$item('#buttonXbrl').link = xbrlLink;
		} else {
			$item('#buttonXbrl').hide();
		}

		$item("#secLink").html = `<p><span style="font-family:helveticaneuew01-45ligh;text-decoration: underline;"><a href="${itemData.link}">HTML</a></span></p>`;
		$item("#secLink").onMouseIn(() => {
			$item("#secLink").html = `<p><span style="font-family:helveticaneuew01-45ligh;text-decoration: underline;color: #0067ff;"><a href="${itemData.link}">HTML</a></span></p>`;
		})
		$item("#secLink").onMouseOut(() => {
			$item("#secLink").html = `<p><span style="font-family:helveticaneuew01-45ligh;text-decoration: underline;"><a href="${itemData.link}">HTML</a></span></p>`;
		});

		if ((index + 1) === repeaterData.length) {
			$item('#secItemSep').collapse();
		}
	});

	$w("#secFilingsRepeater").data = repeaterData;
}